import { useDispatch, useSelector } from 'react-redux'
import { setItineraryData, showItineraryPopup } from '../../../actions/main-actions'

export default function useItinerary() {
  const selectedTrip = useSelector((state) => state.selectedTrip)
  const shopInfo = useSelector((state) => state.shopInfo)
  const dispatch = useDispatch()
  const showItinerary = (elementToScroll) => {
    dispatch(setItineraryData({
      isCharter: selectedTrip.isCharter,
      itinerarySlug: selectedTrip.itinerary.slug,
      tripId: selectedTrip.id,
      dateFrom: selectedTrip.startDate,
      duration: selectedTrip.duration,
      promotion: selectedTrip.promotion,
      price: selectedTrip.price,
      compareAtPrice: selectedTrip.compareAtPrice,
      currency: shopInfo.currency,
      shopSlug: shopInfo.slug,
      countrySlug: shopInfo.countrySlug,
      elementToScroll,
      insurance: shopInfo.insurance,
    }))
    dispatch(showItineraryPopup(true))
  }

  return { showItinerary }
}
